import {getCookie, setCookie, deleteCookie} from '@@/js/utils/cookies';

const compareBtns = document.querySelectorAll('[data-compare]');
const removeBtns = document.querySelectorAll('[data-compare-remove-button]');
const counter = document.querySelector('[data-compare-count]');

compareBtns && compareBtns.forEach(compareBtn => {
  compareBtn.addEventListener('click', () => {
    const id = compareBtn.getAttribute('data-compare');
    const compareCookie = getCookie('compareList') || '';
    const compareList = compareCookie ? compareCookie.split(',') : [];

    if (!compareList.includes(id)) {
      compareList.push(id);
      const count = compareList.length;
      setCookie('compareList', compareList.join(','));

      counter.textContent = `(${count})`;
      compareBtn.classList.add('is-added')
    }
  })
})

removeBtns && removeBtns.forEach(removeBtn => {
  removeBtn.addEventListener('click', () => {
    const id = removeBtn.getAttribute('data-compare-remove-button');
    const compareCookie = getCookie('compareList') || '';
    const compareList = compareCookie ? compareCookie.split(',') : [];
    const products = document.querySelectorAll(`[data-compare-id="${id}"]`)

    if (compareList.includes(id)) {
      const count = compareList.length;
      compareList.splice(compareList.indexOf(id), 1);

      counter.textContent = `(${count - 1})`;
      products.forEach(p => p.remove())

      if (compareList.length) {
        setCookie('compareList', compareList.join(','));
      } else {
        deleteCookie('compareList');
        location.reload()
      }
    }
  })
})
